import { render, staticRenderFns } from "./VeSpacingPicker.vue?vue&type=template&id=10487a1b&scoped=true"
import script from "./VeSpacingPicker.vue?vue&type=script&lang=js"
export * from "./VeSpacingPicker.vue?vue&type=script&lang=js"
import style0 from "./VeSpacingPicker.vue?vue&type=style&index=0&id=10487a1b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10487a1b",
  null
  
)

export default component.exports